import type { DimensionValue, ImageURISource } from "react-native";

import type { SpacingProps } from "../../utils/layout";

export const FALLBACK_ASPECT_RATIO = 1.5;

export type Sizing = {
  width?: DimensionValue;
  height?: DimensionValue;
  maxWidth?: DimensionValue;
  maxHeight?: DimensionValue;
  minWidth?: DimensionValue;
  minHeight?: DimensionValue;
  aspectRatio?: number;
};

export type ResponsiveImageSrc =
  | string
  | ImageURISource
  | { web: string; native: number | string | ImageURISource };

export type ResponsiveImageProps = Sizing &
  SpacingProps & {
    src: ResponsiveImageSrc;
    objectFit?: "contain" | "cover";
    alt: string;
    testID?: string;
  };

export const isSplit = (
  src: ResponsiveImageSrc,
): src is { web: string; native: number | string | ImageURISource } =>
  typeof src === "object" && src !== null && "web" in src && "native" in src;
